<template>
  <svg
    aria-hidden="true"
    :class="['svg-icon', $attrs.class, spin && 'svg-icon-spin']"
    :style="getStyle"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>
<script lang="ts">
export default {
  name: 'SvgIcon',
  inheritAttrs: true,

  props: {
    prefix: {
      type: String,
      default: 'icon',
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    width: {
      type: [Number, String],
    },
    height: {
      type: [Number, String],
    },
    spin: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    symbolId() {
      return `#${this.prefix}-${this.name}`
    },

    getStyle({ size, width, height }) {
      let w = Number(size)
      let h = Number(size)
      if (width && Number(width)) {
        w = Number(width)
      }
      if (height && Number(height)) {
        h = Number(height)
      }

      return {
        '--svg-icon-width': `${w}px`,
        '--svg-icon-height': `${h}px`,
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.svg-icon {
  display: inline-block;
  overflow: hidden;
  vertical-align: -0.15em;
  fill: currentColor;
  --svg-icon-width: 16px;
  --svg-icon-height: 16px;
  width: var(--svg-icon-width);
  height: var(--svg-icon-height);
}

.svg-icon-spin {
  animation: loadingCircle 1s infinite linear;
}

// $size-list: (
//   font14 14px,
//   font16 16px,
//   font18 18px,
//   font20 20px,
//   font22 22px,
//   font24 24px,
//   font30 30px,
//   font36 36px,
//   font40 40px,
//   font180 180px
// );

// @each $value in $size-list {
//   .svg-icon-#{nth($value, 1)} {
//     width: nth($value, 2);
//     height: nth($value, 2);
//   }
// }
</style>
